import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Banner from "./components/Banner";
import AnalysisPage from "./components/AnalysisPage";
import Image from "../../assets/Banner/banner5.jpg";

const styles = {
  paperContainer: {
    height: 350,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Analysis = () => {
  return (
    <Box>
      <Helmet>
        <title>
          State-by-State Appraisals | States Fiscal Transparency League
        </title>
      </Helmet>
      <Box style={styles.paperContainer}>
        <Banner />
      </Box>
      <Box>
        <Container>
          <AnalysisPage />
        </Container>
      </Box>
    </Box>
  );
};

export default Analysis;
